module.exports = __webpack_public_path__ + "img/keep_calm.5de73b97.png";